var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputIdIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C13.2124 12 14.3752 11.5259 15.2325 10.682C16.0898 9.83807 16.5714 8.69347 16.5714 7.5C16.5714 6.30653 16.0898 5.16193 15.2325 4.31802C14.3752 3.47411 13.2124 3 12 3C10.7876 3 9.62482 3.47411 8.76751 4.31802C7.9102 5.16193 7.42857 6.30653 7.42857 7.5C7.42857 8.69347 7.9102 9.83807 8.76751 10.682C9.62482 11.5259 10.7876 12 12 12ZM10.3679 13.6875C6.85 13.6875 4 16.493 4 19.9559C4 20.5324 4.475 21 5.06071 21H18.9393C19.525 21 20 20.5324 20 19.9559C20 16.493 17.15 13.6875 13.6321 13.6875H10.3679Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputIdIco);
export default __webpack_public_path__ + "static/media/Input_id_ico.00fcc292b09bf00e30f003a373a2beed.svg";
export { ForwardRef as ReactComponent };